import React from 'react';

var MobileGameColumn = function (_a) {
    var children = _a.children, _b = _a.position, position = _b === void 0 ? 'top' : _b;
    return React.createElement("div", { className: "".concat(position, "-mobile-wr") }, children);
};

export { MobileGameColumn };
